import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-left",
  "use": "icon-arrow-left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-arrow-left\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M15.894 18.894c.26-.26.29-.664.087-.956l-.087-.104L10.061 12l5.833-5.834c.26-.26.29-.664.087-.956l-.087-.104a.749.749 0 0 0-.956-.087l-.104.087L8.47 11.47a.749.749 0 0 0-.087.956l.087.104 6.364 6.364a.749.749 0 0 0 1.06 0z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol